import { config } from 'lib-shared-backend-config';
import { electron } from 'lib-shared-electron';
import { ampli, groupIdentify } from 'lib-shared-tracking';

import { isPWA } from 'app/middleware/visibility/utils/helpers';

import { InitTrackingPayload } from './types';

async function getDesktopAppVersion(): Promise<string | undefined> {
  if (!electron.isElectron()) {
    return undefined;
  }
  return await window.electron?.getVersion();
}

export async function initTracking({
  user,
  organization,
}: InitTrackingPayload): Promise<void> {
  if (organization.id === '980811c9-72ee-41df-8167-8cb0686072bc') {
    // We don't load tracking on automated test orgs, in order to not pollute BI data.
    return;
  }

  await ampli.load({
    environment: config.sdk.amplitude.environment,
    client: {
      configuration: {
        defaultTracking: {
          attribution: false,
          fileDownloads: false,
          formInteractions: false,
          pageViews: true,
          sessions: false,
        },
      },
    },
  }).promise;

  await ampli.identify(user.id, {
    name: user.name ?? undefined,
    email: user.email ?? '',
    avatar: user.avatar_url ?? undefined,
    phone: user.phone_number ?? undefined,
    bundleTimestamp: TIMESTAMP.trim(),
    bundleVersion: VERSION.trim(),
    desktopAppVersion: electron.isElectron()
      ? await getDesktopAppVersion()
      : 'n/a',
    isPwa: isPWA(),
  }).promise;

  await groupIdentify('organization', organization.name, {
    organization_id: organization.id,
    name: organization.name,
    avatar: organization.avatar_url,
    subdomain: organization.subdomain,
    website: location.origin,
    created_at: organization.created_at,
    trial_ended_at: organization.trial_ended_at,
    suspended: organization.suspended,
  }).promise;

  await ampli.client.setGroup('organization', organization.name).promise;
}
